enum StatisticIndicatorType {
    ET0 = "ETO",

    ET = "ET",

    PLUIE = "pluie",

    IRRIGATION = "irrigation",

    DE = "DE",

    RAWC = "RAWc",

    FCOVER = "fcover",
    FCOVER_VERDE_SD = "fcover_verde_sd",

    GDD = "GDD",

    N_TOT = "n_tot",

    N_SOIL = "n_sol",

    P = "p",

    K = "k",

    S = "s",

    MG = "mg",

    C = "c",

    BIOMASS = "biomass",

    DYN_N = "dyn_n",

    TAW = "TAW",

    RAW = "RAW",

    RECO = "RECO",

    HYDRO_STRESS_LEVEL = "hydro_stress_level",

    LAI = "lai",
    LAI_VERDE_SD = "lai_verde_sd",

    NDVI_PLANET = "ndvi_planet",
    NDVI_PLANET_SD = "ndvi_planet_sd",

    NDVI = "ndvi",

    RAPESEED_FERTILIZATION = "rapeseed_fertilization",
    WHEAT_FERTILIZATION = "wheat_fertilization",
    ABSORBED_NITROGEN = 'absorbed_nitrogen',
    BIOMASS_EARLY_WINTER = 'biomass_ew',
    BIOMASS_LATE_WINTER = 'biomass_lw',
    TOTAL_NEED = 'total_need',
    YIELD_POTENTIAL = 'yield_potential',


}

export default StatisticIndicatorType;
